export default "__VITE_ASSET__D8L0akD$__"